<template>
  <div>
    <a-cascader
      v-model:value="cascadeValue"
      :options="cascadeOptions"
      :placeholder="required ? `请选择${tagType.type_name}（必选）` : `请选择${tagType.type_name}（可选）`"
      :multiple="true"
      :show-search="true"
      :show-checked-strategy="'SHOW_CHILD'"
      style="width: 100%"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { getCascadeTags } from '../api/tagType';

export default {
  name: 'CascadeTagSelector',
  props: {
    tagType: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const cascadeOptions = ref([]);
    const cascadeValue = ref([]);

    // 构建级联选项
    const buildCascadeOptions = (data) => {
      const options = [];
      data.forEach(item => {
        const option = {
          value: item.id,
          label: item.value_name,
          children: item.children && item.children.length > 0 ? buildCascadeOptions(item.children) : undefined
        };
        options.push(option);
      });
      return options;
    };

    // 获取最终层级的标签ID
    const getLeafIds = (options, paths) => {
      const leafIds = [];
      paths.forEach(path => {
        if (path && path.length > 0) {
          // 取路径的最后一个值（最终层级）
          leafIds.push(path[path.length - 1]);
        }
      });
      return leafIds;
    };

    // 变化处理
    const handleChange = (value) => {
      cascadeValue.value = value;
      // 获取最终层级的标签ID数组
      const leafIds = getLeafIds(cascadeOptions.value, value);
      emit('change', leafIds);
    };

    // 加载联动标签
    const loadCascadeTags = async () => {
      try {
        const res = await getCascadeTags(props.tagType.id);
        cascadeOptions.value = buildCascadeOptions(res.data || []);
      } catch (error) {
        console.error('加载联动标签失败:', error);
      }
    };

    // 根据标签ID构建路径（用于回显）
    const buildPathFromId = (id, options, path = []) => {
      for (const option of options) {
        const currentPath = [...path, option.value];
        if (option.value === id) {
          return currentPath;
        }
        if (option.children) {
          const found = buildPathFromId(id, option.children, currentPath);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };

    // 初始化值
    const initValue = () => {
      if (props.value && props.value.length > 0) {
        const paths = [];
        props.value.forEach(id => {
          const path = buildPathFromId(id, cascadeOptions.value);
          if (path) {
            paths.push(path);
          }
        });
        cascadeValue.value = paths;
      }
    };

    watch(() => props.value, () => {
      initValue();
    }, { immediate: true, deep: true });

    watch(() => cascadeOptions.value, () => {
      initValue();
    }, { deep: true });

    onMounted(() => {
      loadCascadeTags();
    });

    return {
      cascadeOptions,
      cascadeValue,
      handleChange
    };
  }
};
</script>

